import { Injectable } from '@angular/core';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { HttpClient } from '@node_modules/@angular/common/http';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';


@Injectable({
  providedIn: 'root'
})
export class ZonasService extends UtilidadesCrudService {

  constructor(
    http: HttpClient,
    public auxiliar: AuxiliarService,
  ) {
    super(
      http,
      auxiliar,
      'zonas', /*zonas*/
      'zonas', /*zonas*/
      'Zona',
      'Zonas',
      [
        'id',
        'activo',
        'nombre'
      ]
    );
  }

  patchFicheros(id: string, idFichero: string, request: any) {
      return this.http.patch(`${this.urlEntidad}/${idFichero}/ficheros`, {...request, destacado: 1}).pipe(
          map((resp: IRespApi) => resp.data),
          catchError((err: IRespApi) => {
              return this.handleError(err, `IRequestEditar${this.identificadorEntidad}Fichero`);
          })
      );
  }

  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {};
    const id = route.params?.id;   
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    if (Object.keys(peticion).length > 0) {
      return forkJoin(peticion);
    } else {
      of(true);
    }
  }

}
